const values = {
  COLORS: {
    darkTextColor: "#000",
    lightTextColor: "#FFF",
    mainLightBackgroundColor: "#fafafa",
    secondLightBackgroundColor: "#f5f5f5",
    darkBackgroundColor: "#000",
    darkShadowColor: "#282828",
    lightShadowColor: "#D3D3D3",
  },
  FONTSIZES: {
    primaryTextFontSize: "1rem",
    secondaryTextFontSize: "1.25rem",
  },
  DEVICESIZE: {
    mobileS: "320px", //"320px",
    mobileM: "375px", //"375px",
    mobileL: "425px", //"425px",
    tablet: "768px", //"768px",
    laptop: "1024px", //"1024px",
    laptopL: "1440px", //"1440px",
    desktop: "2560px", //"2560px",
  },
}

export default values
